import { jsx as a } from "react/jsx-runtime";
import m from "classnames";
import '../../assets/StepList.css';const o = "_steps_19e4s_9", r = "_small_19e4s_25", _ = "_large_19e4s_36", s = {
  steps: o,
  small: r,
  large: _
}, n = ({ children: e, size: t = "medium", className: l }) => /* @__PURE__ */ a("ol", { className: m(s.steps, s[t], l), children: e });
export {
  n as default
};
